<div class="container-fluid search-bar">
    <div class="container" #searchContainer>
        <div>
            <div class="search-input">
                <mat-form-field appearance="outline" class="w-100 p-0">
                    <mat-label>{{'Catalogue.searchProduct'|translate}}</mat-label>
                    <input matInput type="text" [(ngModel)]="searchTerm"
                        (keyup)="onSearchInput()" placeholder="{{'Catalogue.searchPlaceholder'|translate}}">
                </mat-form-field>
    
                <div class="search-btn-div">
                    <button class="btn-primary w-100 p-0" mat-raised-button>
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
    
    
                <div class="autocomplete-list" *ngIf="autocompleteList.length>0">
                    <ul class="p-0">
                        <li class="ac-li" *ngFor="let item of autocompleteList" (click)="selectItem(item)">
                            {{item.referenceProduct ? item.referenceProduct : item.nom}} - {{item.shortDescription?.fr_FR}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="search-bloc" style="width: 50px;height: 60px;"></div>